import React from 'react'
import classNames from 'classnames'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import 'froala-editor/css/froala_editor.pkgd.min.css' // requires a loader
import { Carousel } from 'react-responsive-carousel'
import useStyles from './styled'
import WarpImgLink from '../../components/WarpImgLink'
const BannerSlide = props => {
  const { banner } = props
  const classes = useStyles()
  const indicatorActiveClasses = classNames({
    [classes.indicator]: true,
    [classes.indicatorActive]: true,
  })
  return (
    <div className={classes.banner}>
      <Carousel
        showArrows={false}
        showThumbs={false}
        showIndicators={banner.length > 1 ? true : false}
        emulateTouch
        autoPlay
        infiniteLoop
        showStatus={false}
        interval={5000}
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          if (isSelected) {
            return <li className={indicatorActiveClasses} />
          }
          return <li onClick={onClickHandler} className={classes.indicator} />
        }}
      >
        {banner.map((row, key) => {
          return (
            <div key={key}>
              <WarpImgLink imageObject={row} />
            </div>
          )
        })}
      </Carousel>
    </div>
  )
}

export default BannerSlide
